import { jsx as _jsx } from "react/jsx-runtime";
import { useRouter } from '@tanstack/react-router';
import { SheetErrorFallback } from '../sheet-error-fallback';
/**
 * Errore di una rotta figlia aperta in un pannello laterale, per web e
 * backoffice: resta dentro il pannello (la lista sotto non sparisce),
 * «Chiudi» chiama `onClose`, «Riprova» azzera l'errore e rilegge la rotta.
 */
export function SheetRouteError({ reset, onClose, size, }) {
    const router = useRouter();
    return (_jsx(SheetErrorFallback, { size: size, onClose: onClose, onRetry: () => {
            reset();
            void router.invalidate();
        } }));
}
//# sourceMappingURL=index.js.map